exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".zapier-1{\n  fill:#fff;\n  stroke:#707070;\n}\n.zapier-2{\n  clip-path:url(#clip-path);\n}\n.zapier-3{\n  fill:#ff4a00;\n  opacity:.759;\n}\n", ""]);
